var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrade(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 148,
    height: 148,
    viewBox: "0 0 148 148",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{clip-path:url(#a);}.c{fill:#f5f5f5;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 148,
    height: 148
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "b"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1538 -1292)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 9,
    height: 9,
    rx: 1,
    transform: "translate(1538 1292)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1517 -1292)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 9,
    height: 9,
    rx: 1,
    transform: "translate(1538 1292)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1496 -1292)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 9,
    height: 9,
    rx: 1,
    transform: "translate(1538 1292)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1475 -1292)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 9,
    height: 9,
    rx: 1,
    transform: "translate(1538 1292)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1454 -1292)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 9,
    height: 9,
    rx: 1,
    transform: "translate(1538 1292)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1433 -1292)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 9,
    height: 9,
    rx: 1,
    transform: "translate(1538 1292)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1412 -1292)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 9,
    height: 9,
    rx: 1,
    transform: "translate(1538 1292)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1538 -1271)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 9,
    height: 9,
    rx: 1,
    transform: "translate(1538 1292)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1517 -1271)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 9,
    height: 9,
    rx: 1,
    transform: "translate(1538 1292)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1496 -1271)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 9,
    height: 9,
    rx: 1,
    transform: "translate(1538 1292)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1475 -1271)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 9,
    height: 9,
    rx: 1,
    transform: "translate(1538 1292)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1454 -1271)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 9,
    height: 9,
    rx: 1,
    transform: "translate(1538 1292)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1433 -1271)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 9,
    height: 9,
    rx: 1,
    transform: "translate(1538 1292)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1412 -1271)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 9,
    height: 9,
    rx: 1,
    transform: "translate(1538 1292)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1538 -1250)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 9,
    height: 9,
    rx: 1,
    transform: "translate(1538 1292)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1517 -1250)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 9,
    height: 9,
    rx: 1,
    transform: "translate(1538 1292)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1496 -1250)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 9,
    height: 9,
    rx: 1,
    transform: "translate(1538 1292)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1475 -1250)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 9,
    height: 9,
    rx: 1,
    transform: "translate(1538 1292)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1454 -1250)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 9,
    height: 9,
    rx: 1,
    transform: "translate(1538 1292)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1433 -1250)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 9,
    height: 9,
    rx: 1,
    transform: "translate(1538 1292)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1412 -1250)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 9,
    height: 9,
    rx: 1,
    transform: "translate(1538 1292)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1538 -1229)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 9,
    height: 9,
    rx: 1,
    transform: "translate(1538 1292)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1517 -1229)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 9,
    height: 9,
    rx: 1,
    transform: "translate(1538 1292)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1496 -1229)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 9,
    height: 9,
    rx: 1,
    transform: "translate(1538 1292)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1475 -1229)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 9,
    height: 9,
    rx: 1,
    transform: "translate(1538 1292)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1454 -1229)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 9,
    height: 9,
    rx: 1,
    transform: "translate(1538 1292)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1433 -1229)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 9,
    height: 9,
    rx: 1,
    transform: "translate(1538 1292)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1412 -1229)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 9,
    height: 9,
    rx: 1,
    transform: "translate(1538 1292)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1538 -1208)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 9,
    height: 9,
    rx: 1,
    transform: "translate(1538 1292)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1517 -1208)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 9,
    height: 9,
    rx: 1,
    transform: "translate(1538 1292)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1496 -1208)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 9,
    height: 9,
    rx: 1,
    transform: "translate(1538 1292)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1475 -1208)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 9,
    height: 9,
    rx: 1,
    transform: "translate(1538 1292)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1454 -1208)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 9,
    height: 9,
    rx: 1,
    transform: "translate(1538 1292)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1433 -1208)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 9,
    height: 9,
    rx: 1,
    transform: "translate(1538 1292)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1412 -1208)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 9,
    height: 9,
    rx: 1,
    transform: "translate(1538 1292)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1538 -1187)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 9,
    height: 9,
    rx: 1,
    transform: "translate(1538 1292)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1517 -1187)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 9,
    height: 9,
    rx: 1,
    transform: "translate(1538 1292)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1496 -1187)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 9,
    height: 9,
    rx: 1,
    transform: "translate(1538 1292)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1475 -1187)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 9,
    height: 9,
    rx: 1,
    transform: "translate(1538 1292)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1454 -1187)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 9,
    height: 9,
    rx: 1,
    transform: "translate(1538 1292)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1433 -1187)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 9,
    height: 9,
    rx: 1,
    transform: "translate(1538 1292)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1412 -1187)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 9,
    height: 9,
    rx: 1,
    transform: "translate(1538 1292)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1538 -1166)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 9,
    height: 9,
    rx: 1,
    transform: "translate(1538 1292)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1517 -1166)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 9,
    height: 9,
    rx: 1,
    transform: "translate(1538 1292)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1496 -1166)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 9,
    height: 9,
    rx: 1,
    transform: "translate(1538 1292)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1475 -1166)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 9,
    height: 9,
    rx: 1,
    transform: "translate(1538 1292)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1454 -1166)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 9,
    height: 9,
    rx: 1,
    transform: "translate(1538 1292)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1433 -1166)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 9,
    height: 9,
    rx: 1,
    transform: "translate(1538 1292)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1412 -1166)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 9,
    height: 9,
    rx: 1,
    transform: "translate(1538 1292)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrade);
export default __webpack_public_path__ + "static/media/grade.7a39d5f8f99b5ab400437438b130f033.svg";
export { ForwardRef as ReactComponent };